(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["spotify-sheet"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__sbsInit) return;
    window.__sbsInit = true;

    const STORE = 'spotifySheet';
    let sheet = null;

    const registerStore = () => {
      if (!window.Alpine || Alpine.store(STORE) !== undefined) return;

      Alpine.store(STORE, {
        isOpen: false,
        src: '',
        title: '',
        show(src, title) {
          this.src = src;
          this.title = title;
          this.isOpen = true;
          openSheet(src, title);
        },
        hide() {
          this.isOpen = false;
          if (sheet) sheet.close();
          setTimeout(() => {
            if (!this.isOpen) this.src = '';
          }, 420);
        },
      });
    };

    const openSheet = (src, title) => {
      if (!window.BottomSheet) return;

      /* Destroy previous sheet if it exists */
      if (sheet) {
        try {
          sheet.unmount();
        } catch (e) {}
        sheet = null;
      }

      /* Create a fresh sheet instance each time */
      sheet = window.BottomSheet.createBottomSheet({
        content: `
          <div class="sbs-iframe-wrap">
            <iframe
              class="sbs-iframe"
              src="${src}"
              height="152"
              frameborder="0"
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              title="Spotify player: ${title}"
            ></iframe>
          </div>
        `,
        draggable: true,
        shouldCloseOnOutsideClick: true,
        shouldShowHandle: true,
        shouldShowBackdrop: true,
        expandable: false,
        backdropColor: 'rgba(0, 0, 0, 0.6)',
        containerBorderRadius: '20px',
        containerClass: 'pbs-container',
        handleClass: 'pbs-handle',
        onClose: () => {
          if (window.Alpine) {
            const store = Alpine.store(STORE);
            if (store) {
              store.isOpen = false;
              setTimeout(() => {
                if (!store.isOpen) store.src = '';
              }, 420);
            }
          }
        },
      });

      sheet.mount();
      sheet.open();
    };

    const setup = () => {
      registerStore();
    };

    document.addEventListener('alpine:init', registerStore);

    if (window.Alpine) {
      setup();
    } else {
      document.addEventListener('alpine:initialized', setup, { once: true });
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden && window.Alpine) Alpine.store(STORE)?.hide();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
